import './BottomBar.sass';

import React, { FC } from 'react';
import { BottomBarProps } from './BottomBar.interface';

import { classNames } from '$utils';

export const BottomBar: FC<BottomBarProps> = ({
  children,
  fixed = false,
  direction = 'row',
  className,
  hasSafeArea = true,
}) => {
  return (
    <div
      className={classNames(direction, className, {
        BottomBar: true,
        fixed,
        hasSafeArea,
      })}
    >
      <div className="BottomBar__in">
        <div className="BottomBar__content">{children}</div>
      </div>
    </div>
  );
};
